"use client";

import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useCart } from "./cartContext";

export default function CartPage () {
    const [cartItems, setCartItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isCheckingOut, setIsCheckingOut] = useState(false);
    const userId = Cookies.get("userId"); // Make sure this matches your cookie name

    const { updateCartCount } = useCart();


    const updateQuantity = async (id, newQuantity) => {
        if (newQuantity < 1) return;

        const userId = Cookies.get("userId");
        if (!userId) {
            toast.error("Please log in to update cart");
            return;
        }

        setIsUpdating(true);
        try {
            const formData = new FormData();
            formData.append("user_id", userId);
            formData.append("product_id", id);
            formData.append("quantity", newQuantity);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_update_cart.php", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success || result.status === "success") {
                // Instead of updating local state directly, refetch the cart
                await fetchCartData(); // Call the fetch function again
                toast.success("Cart updated successfully");
            } else {
                throw new Error(result.message || "Failed to update cart");
            }
        } catch (error) {
            console.error("Error updating cart:", error);
            toast.error("Failed to update cart");
        } finally {
            setIsUpdating(false);
        }
    };

    // const removeItem = async (id) => {
    //     const userId = Cookies.get("userId");
    //     if (!userId) {
    //         toast.error("Please log in to remove items");
    //         return;
    //     }
    //     setIsUpdating(true);
    //     try {
    //         const formData = new FormData();
    //         formData.append("user_id", userId);
    //         formData.append("product_id", id.toString());
    //         const response = await fetch("https://leapatinternational.com/admin/api/v1/web_remove_from_cart.php", {
    //             method: "POST",
    //             body: formData,
    //         });

    //         if (!response.ok) {
    //             throw new Error(`HTTP error! status: ${response.status}`);
    //         }

    //         const result = await response.json();

    //         if (result.success || result.status === "success") {
    //             await fetchCartData(); // Call the fetch function again
    //             toast.success("Item removed from cart");
    //         } else {
    //             throw new Error(result.message || "Failed to remove item");
    //         }
    //     } catch (error) {
    //         console.error("Error removing item:", error);
    //         toast.error("Failed to remove item from cart 123123");
    //     } finally {
    //         setIsUpdating(false);
    //     }
    // };

    // Extract the fetch logic to a separate function so it can be reused

    const removeItem = async (id) => {
        const userId = Cookies.get("userId");
        if (!userId) {
            toast.error("Please log in to remove items");
            return;
        }
        setIsUpdating(true);
        try {
            // Optimistic update - remove item from local state immediately
            setCartItems(prevItems => {
                const newItems = prevItems.filter(item => item.product_id !== id);
                return newItems;
            });

            const formData = new FormData();
            formData.append("user_id", userId);
            formData.append("product_id", id.toString());

            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_remove_from_cart.php", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (!(result.success || result.status === "success")) {
                throw new Error(result.message || "Failed to remove item");
            }
            await updateCartCount();
            // Only show success message, no need to refetch since we did optimistic update
            toast.success("Item removed from cart");

        } catch (error) {
            console.error("Error removing item:", error);
            toast.error(error.message || "Failed to remove item from cart");

            // Re-fetch cart data to recover from any state mismatch
            await fetchCartData();
        } finally {
            setIsUpdating(false);
        }
    };

    const fetchCartData = async () => {
        const userId = Cookies.get("userId");
        if (!userId) return;

        try {
            const formData = new FormData();
            formData.append("user_id", userId);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_getcart.php", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success || result.status === "success") {
                const items = result.data || result.items || [];
                setCartItems(items);
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            console.error("Error fetching cart:", error);

        }
    };
    useEffect(() => {
        fetchCartData();
    }, []);
    const handleCheckout = async () => {
        if (!userId) {
            toast.error("Please log in to place order");
            return;
        }

        if (cartItems.length === 0) {
            toast.error("Your cart is empty");
            return;
        }

        setIsCheckingOut(true);

        try {
            const formData = new FormData();
            formData.append("user_id", userId);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_place_order.php", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success || result.status === "success") {
                toast.success("Order placed successfully!");

                window.location.href = "/order-complate";
                setCartItems([]);

                // You might want to redirect to order confirmation page
                // window.location.href = '/order-confirmation'
            } else {
                throw new Error(result.message || "Failed to place order");
            }
        } catch (error) {
            console.error("Error placing order:", error);
            toast.error("Failed to place order. Please try again.");
        } finally {
            setIsCheckingOut(false);
        }
    };

    const getSubtotal = () => {
        return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
    };



    const getTotal = () => {
        return getSubtotal();
    };


    return (
        <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa", paddingBottom: "40px", marginTop: "135px" }}>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        {/* Page Header */}
                        <div className="text-center" style={{ marginBottom: "40px" }}>
                            <h1 style={{ fontWeight: "700", color: "#1f2937", fontSize: "2.5rem", marginBottom: "10px" }}>
                                Shopping Cart
                            </h1>
                            <p style={{ color: "#6b7280", fontSize: "1.1rem" }}>
                                {cartItems.length} {cartItems.length === 1 ? "item" : "items"} in your cart
                            </p>
                        </div>

                        <div className="row g-4">
                            {/* Cart Items Section */}
                            <div className="col-12 col-lg-8">
                                <div
                                    className="card"
                                    style={{
                                        border: "none",
                                        borderRadius: "20px",
                                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                                        padding: "30px",
                                    }}
                                >
                                    <h3 style={{ fontWeight: "600", color: "#1f2937", marginBottom: "30px" }}>Cart Items</h3>

                                    {cartItems.length === 0 ? (
                                        <div className="text-center" style={{ padding: "60px 20px" }}>
                                            <div style={{ fontSize: "4rem", marginBottom: "20px" }}>🛒</div>
                                            <h4 style={{ color: "#6b7280", fontWeight: "500" }}>Your cart is empty</h4>
                                            <p style={{ color: "#9ca3af", marginTop: "10px" }}>Add some products to get started!</p>
                                        </div>
                                    ) : (
                                        <div>
                                            {cartItems.map((item, index) => (
                                                <div key={item.id}>
                                                    <div
                                                        className="row align-items-center"
                                                        style={{
                                                            padding: "20px 0",
                                                            borderBottom: index < cartItems.length - 1 ? "1px solid #e5e7eb" : "none",
                                                        }}
                                                    >
                                                        {/* Product Image */}
                                                        <div className="col-12 col-md-3">
                                                            <img
                                                                src={item.image_url || "/placeholder.svg"}
                                                                alt={item.name}
                                                                className="img-fluid"
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "120px",
                                                                    height: "120px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "15px",
                                                                    backgroundColor: "#f8f9fa",
                                                                }}
                                                            />
                                                        </div>

                                                        {/* Product Details */}
                                                        <div className="col-12 col-md-5" style={{ marginTop: "15px" }}>
                                                            <h5 style={{ fontWeight: "600", color: "#1f2937", marginBottom: "8px" }}>{item.name}</h5>
                                                            <p style={{ color: "#6b7280", fontSize: "0.9rem", marginBottom: "10px" }}>
                                                                {item.description}
                                                            </p>
                                                            <span style={{ fontSize: "1.2rem", fontWeight: "700", color: "rgba(73, 78, 161, 1)" }}>
                                                                ${item.price.toFixed(2)}
                                                            </span>
                                                        </div>

                                                        {/* Quantity Controls */}
                                                        <div className="col-12 col-md-2" style={{ marginTop: "15px" }}>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <button
                                                                    className="btn"
                                                                    onClick={() => updateQuantity(item.product_id
                                                                        , item.quantity - 1)}
                                                                    style={{
                                                                        width: "35px",
                                                                        height: "35px",
                                                                        borderRadius: "8px",
                                                                        border: "2px solid #e5e7eb",
                                                                        backgroundColor: "white",
                                                                        color: "#374151",
                                                                        fontSize: "18px",
                                                                        fontWeight: "600",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        transition: "all 0.3s ease",
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.borderColor = "#3b82f6";
                                                                        e.currentTarget.style.backgroundColor = "#f0f9ff";
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.borderColor = "#e5e7eb";
                                                                        e.currentTarget.style.backgroundColor = "white";
                                                                    }}
                                                                >
                                                                    -
                                                                </button>

                                                                <span
                                                                    style={{
                                                                        margin: "0 15px",
                                                                        fontSize: "1.1rem",
                                                                        fontWeight: "600",
                                                                        minWidth: "30px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {item.quantity}
                                                                </span>

                                                                <button
                                                                    className="btn"
                                                                    onClick={() => updateQuantity(item.product_id
                                                                        , item.quantity + 1)}
                                                                    style={{
                                                                        width: "35px",
                                                                        height: "35px",
                                                                        borderRadius: "8px",
                                                                        border: "2px solid #e5e7eb",
                                                                        backgroundColor: "white",
                                                                        color: "#374151",
                                                                        fontSize: "18px",
                                                                        fontWeight: "600",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        transition: "all 0.3s ease",
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.borderColor = "#3b82f6";
                                                                        e.currentTarget.style.backgroundColor = "#f0f9ff";
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.borderColor = "#e5e7eb";
                                                                        e.currentTarget.style.backgroundColor = "white";
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Item Total & Remove */}
                                                        <div className="col-12 col-md-2 text-center" style={{ marginTop: "15px" }}>
                                                            <div style={{ marginBottom: "15px" }}>
                                                                <span
                                                                    style={{
                                                                        fontSize: "1.3rem",
                                                                        fontWeight: "700",
                                                                        color: "#1f2937",
                                                                    }}
                                                                >
                                                                    ${(item.price * item.quantity).toFixed(2)}
                                                                </span>
                                                            </div>
                                                            <button
                                                                className="btn"
                                                                onClick={() => removeItem(item.product_id)}
                                                                style={{
                                                                    backgroundColor: "#fee2e2",
                                                                    color: "#dc2626",
                                                                    border: "none",
                                                                    borderRadius: "8px",
                                                                    padding: "8px 12px",
                                                                    fontSize: "0.9rem",
                                                                    fontWeight: "500",
                                                                    transition: "all 0.3s ease",
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#fecaca";
                                                                    e.currentTarget.style.transform = "translateY(-1px)";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#fee2e2";
                                                                    e.currentTarget.style.transform = "translateY(0)";
                                                                }}
                                                            >
                                                                🗑️ Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Order Summary Section */}
                            <div className="col-12 col-lg-4">
                                <div
                                    className="card"
                                    style={{
                                        border: "none",
                                        borderRadius: "20px",
                                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                                        padding: "30px",
                                        position: "sticky",
                                        top: "20px",
                                    }}
                                >
                                    <h3 style={{ fontWeight: "600", color: "#1f2937", marginBottom: "30px" }}>Order Summary</h3>

                                    <div style={{ marginBottom: "20px" }}>
                                        <div className="d-flex justify-content-between" style={{ marginBottom: "15px" }}>
                                            <span style={{ color: "#6b7280" }}>Subtotal:</span>
                                            <span style={{ fontWeight: "600", color: "#1f2937" }}>${getSubtotal().toFixed(2)}</span>
                                        </div>



                                        <div className="d-flex justify-content-between" style={{ marginBottom: "15px" }}>
                                            <span style={{ color: "#6b7280" }}>Shipping:</span>
                                            <span style={{ fontWeight: "600", color: "#22c55e" }}>Free</span>
                                        </div>

                                        <hr style={{ margin: "20px 0", border: "1px solid #e5e7eb" }} />

                                        <div className="d-flex justify-content-between" style={{ marginBottom: "30px" }}>
                                            <span style={{ fontSize: "1.2rem", fontWeight: "600", color: "#1f2937" }}>Total:</span>
                                            <span style={{ fontSize: "1.5rem", fontWeight: "700", color: "rgba(73, 78, 161, 1)" }}>
                                                ${getTotal().toFixed(2)}
                                            </span>
                                        </div>
                                    </div>

                                    <button
                                        className="btn w-100 btn-signin"
                                        onClick={handleCheckout}
                                        disabled={cartItems.length === 0}
                                        style={{
                                            color: "white",
                                            border: "none",
                                            borderRadius: "15px",
                                            padding: "15px 20px",
                                            fontSize: "1.1rem",
                                            fontWeight: "600",
                                            transition: "all 0.3s ease",
                                            marginBottom: "15px",
                                            cursor: cartItems.length === 0 ? "not-allowed" : "pointer",
                                        }}

                                    >
                                        🛒 Proceed to Checkout
                                    </button>

                                    <button
                                        className="btn w-100"
                                        onClick={() => window.history.back()}
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "#6366f1",
                                            border: "2px solid #6366f1",
                                            borderRadius: "15px",
                                            padding: "12px 20px",
                                            fontSize: "1rem",
                                            fontWeight: "600",
                                            transition: "all 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#6366f1";
                                            e.currentTarget.style.color = "white";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "#6366f1";
                                        }}
                                    >
                                        ← Continue Shopping
                                    </button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
